import React from 'react';
import { cn } from '@/lib/utils';

interface PageHeaderProps {
  title: string;
  description?: string;
  actions?: React.ReactNode;
  className?: string;
}

/**
 * عنوان صفحه زیر نوار عمومی؛ با حاشیه طبق الگوی سامانه‌های سازمانی
 */
const PageHeader: React.FC<PageHeaderProps> = ({ title, description, actions, className }) => (
  <div
    className={cn(
      'flex w-full min-w-0 flex-col gap-3 border-b border-gray-200 pb-4 sm:flex-row sm:items-start sm:justify-between',
      className,
    )}
  >
    <div className="min-w-0">
      <h1 className="text-xl font-bold tracking-tight text-foreground md:text-2xl">{title}</h1>
      {description && <p className="mt-1 max-w-3xl text-sm text-muted-foreground">{description}</p>}
    </div>
    {actions && <div className="flex shrink-0 flex-wrap items-center gap-2">{actions}</div>}
  </div>
);

export default PageHeader;
